export default __webpack_public_path__ + "static/orel-1c5052c5c2416ea218ab6a68549e4735.jpg";